import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "AllCollectionLayoutstyle__Container",
  componentId: "sc-u899r9-0"
})(["", " @media (max-width:", "){", "}"], {
  "marginTop": "8rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "5rem",
  "marginBottom": "5rem"
});
export const Title = styled.h2.withConfig({
  displayName: "AllCollectionLayoutstyle__Title",
  componentId: "sc-u899r9-1"
})(["", " span{", "}@media (max-width:", "){", "}"], {
  "marginBottom": "2rem",
  "fontSize": "56px",
  "fontWeight": "700"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(232 144 158 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "1.5rem",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem"
});
export const Wrapper = styled.div.withConfig({
  displayName: "AllCollectionLayoutstyle__Wrapper",
  componentId: "sc-u899r9-2"
})(["", " @media (max-width:", "){", "}@media (max-width:", "){", "}"], {
  "display": "grid",
  "gridTemplateColumns": "repeat(3, minmax(0, 1fr))",
  "columnGap": "2.25rem",
  "rowGap": "2.5rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "gridTemplateColumns": "repeat(2, minmax(0, 1fr))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))"
});